module.exports = __webpack_public_path__ + "static/media/t2.ba890c1d.png";